import { render, staticRenderFns } from "./createChoose.vue?vue&type=template&id=56bc83d0&scoped=true"
import script from "./createChoose.vue?vue&type=script&lang=js"
export * from "./createChoose.vue?vue&type=script&lang=js"
import style0 from "./createChoose.vue?vue&type=style&index=0&id=56bc83d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bc83d0",
  null
  
)

export default component.exports